import { REACT_APP_QUOTE_VERSION_BR } from '../../config';
import type { QuoterMarketConfig } from '../contract/market';

// Los valores son los que BR tiene hoy en components/quote/BR/*, transcritos uno a uno.
export const BR: QuoterMarketConfig = {
  country: 'BR',
  label: 'Brasil',
  // BR vende la cobertura principal y dos riders de accidentes propios; no ofrece ROP, gastos
  // funerarios, proteccion de ingreso ni enfermedades criticas.
  riders: ['ad', 'tpd'],
  languages: [{ code: 'pt', label: 'Português' }],
  age: { min: 18, max: 71, maxAtExpiry: 75 },
  // Plazo unico: BR no ofrece selector (BR/quoteSummary.tsx:25).
  terms: ['5'],
  termRule: 'ageDerived',
  frequencies: ['M', 'A'],
  mainCoverage: { min: 100000, max: 500000, step: 10000, easyTermMax: null },
  amountRounding: 'down',
  productRule: 'legacyThreshold',
  addRider: null,
  // BR/quoteForm.tsx:20-22
  accidentRiders: { min: 50000, step: 10000, max: 250000 },
  // El tope se reparte entre la cobertura principal y los dos riders (BR/quoteForm.tsx:19,128-131).
  totalCoverageLimit: 500000,
  thousandsSeparator: '.',
  criticalIllnessCancer: null,
  incomeReplacement: null,
  funeralExpenses: null,
  returnOfPremium: null,
  pricingVersion: REACT_APP_QUOTE_VERSION_BR,
  freeInstallmentsPromotion: true,
  brandingSource: 'displayConfig',
  insuredAmountSummary: true,
  editing: { stepperDebounceMs: 800 },
};
